<template>
  <div
    class="card-timeline--uniform review card-popular-review"
    :style="{ height: cardHeight }"
    :class="{ 'expert-review': reviewData.user.is_expert_reviewer }"
  >
    <div class="section-product">
      <router-link :to="urlDetailProduct" class="product-link" @click.native="internalTrack('click', 'product_card')">
        <img
          :src="mainImage(reviewData.product.images[0].url)"
          class="product-img"
          :alt="`${reviewData.product.name}-${reviewData.product.brand.name}`"
          onerror="this.src='/assets/img/dummy_product.svg'"
        />
        <div class="product-desc">
          <p class="product-brand">{{ reviewData.product.brand.name }}</p>
          <p class="product-name">{{ reviewData.product.name }}</p>
        </div>
        <GRatingInline
          :average-rating="reviewAverageRating"
          :inline-reviewers="false"
          :star-fill-number="reviewStarFillNumber"
          :total-stars="1"
        />
      </router-link>
    </div>
    <div class="section-review">
      <div class="review-owner">
        <div class="container-rating-new">
          <GRatingInline
            v-if="reviewAverageRating"
            class-modifier="average-rating--uniform"
            :average-rating="reviewAverageRating.toFixed(1)"
            :star-fill-number="reviewStarFillNumber"
          />
          <img class="label-shopper" src="/assets/img/icon-shopper.svg" alt="" height="16" width="16" />
        </div>
        <p class="owner">
          {{ reviewData.user.name }}
        </p>
      </div>
      <div class="review-detail">
        <div v-if="String(reviewData.details).length > 150" class="review-content--text">
          <div v-if="seeMoreOpen">
            <p class="review-text">
              <span>{{ reviewData.details }}</span>
              <span class="see-more" @click.prevent="toggleSeeMore">Read less</span>
            </p>
          </div>
          <div v-else>
            <p class="review-text">
              <span>{{ reviewData.details | trimRecentReviewContentMobile }}</span>
              <span class="see-more" @click.prevent="toggleSeeMore">Read more</span>
            </p>
          </div>
        </div>
        <div v-else class="review-content--text">
          <span>{{ reviewData.details }}</span>
        </div>
      </div>
      <ListUserPhoto
        v-if="$SO.size(reviewData.images)"
        :key="`list-user-photo-${reviewData['_id']}`"
        :average-rating="reviewData.average_rating ? reviewData.average_rating : 0"
        :details="reviewData.details ? reviewData.details : ''"
        :images="reviewData.images"
        :created_at="reviewData.created_at"
        :user="reviewData.user"
        :section="'popular-review'"
        :max_photo="5"
        :display-remaining-photo="true"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'CardPopularReview',
  components: {
    ListUserPhoto: () => import('@/components/dashboard/snippet/list-user-photo'),
  },
  props: {
    reviewData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      seeMoreOpen: false,
      cardHeight: 'auto',
    };
  },
  computed: {
    urlDetailProduct() {
      const product = this.reviewData.product;
      if (product.default_category) {
        return `/product/${this.$options.filters.slug(product.default_category.name)}/${
          product.id
        }-${this.$options.filters.slug(product.name)}`;
      } else {
        return this.$options.filters.productUrlReview(product);
      }
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    reviewAverageRating() {
      if (this.reviewData.product.review_stats) {
        return this.$options.filters.rating(this.reviewData.product.review_stats.average_rating);
      }
      return null;
    },
    reviewStarFillNumber() {
      if (this.reviewData.product.review_stats) {
        return this.$options.filters.rating(this.reviewData.product.review_stats.average_rating) * 10;
      } else {
        return 0;
      }
    },
  },
  methods: {
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=169',
        image: src,
      });
    },
    internalTrack(verb, object_type) {
      try {
        this.$store.dispatch('$_InternalTracking/track', {
          verb,
          object_id: this.reviewData.product.id,
          object_type,
          target: {
            id: this.reviewData.product.id,
            object_type: 'product_detail',
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    adjustCardHeight() {
      this.$nextTick(() => {
        const cardElement = this.$el;
        if (cardElement) {
          const cardHeight = `${cardElement.offsetHeight}px`;
          this.cardHeight = cardHeight;
        }
      });
    },
    toggleSeeMore() {
      this.seeMoreOpen = !this.seeMoreOpen;
    },
  },
};
</script>
<style lang="scss" scoped>
.see-more {
  color: #dc0034;
  font: 12px/15px 'lato-bold', sans-serif;
  letter-spacing: 1px;
  padding-right: 15px;
  display: inline;
  margin-left: 5px;
}

.review-content {
  word-break: break-all;
}
.card-popular-review {
  transition: height 0.3s ease;
  width: 95%;
  height: auto;
  min-height: 305px;
  box-shadow: none;
  position: relative;
  border: 1px solid #e5e5e5;
  background: inherit;
  border-radius: 4px;
  max-width: 353px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  padding: 0 !important;
  place-self: center;
  @media (max-width: 768px) {
    max-width: 97%;
  }
  p {
    margin: 0 !important;
  }
  .section-product {
    border-radius: 10px;
    margin: 10px 14px;
    display: flex;
    align-items: center;
    align-self: stretch;
    background-color: #ffffff;
    @media (max-width: 786px) {
      margin: 0px 0px 10px;
      .global-rating-inline {
        padding: 10px;
      }
    }
    .product-link {
      display: flex;
      align-items: center;
      text-decoration: none;
      color: inherit;
      width: 100%;
    }
    .product-img {
      width: 72px;
      height: 72px;
      object-fit: cover;
      margin: 12px 0 12px 12px;
    }
    .product-desc {
      display: flex;
      flex-direction: column;
      padding-left: 8px;
      // gap: 8px;
      // width: auto;
      width: 185px;
      .product-brand {
        color: #231f20;
        font-family: 'lato-bold', sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: normal;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        align-items: center;
        padding-bottom: 4px;
        // margin: 0 0 8px 0;
      }
      .product-name {
        color: #231f20;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: 'lato-regular', sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: 16px;
        // margin: 0 0 8px 0;
      }
      .product-review {
        color: rgba(9, 0, 0, 0.4);
        font-family: 'lato-bold', sans-serif;
        font-size: 12px;
        font-style: normal;
        line-height: 16px;
        // margin-top: 0;
      }
    }
    .product-rating {
      display: block;
      text-align: left;
      margin-bottom: 10px;
      align-items: center;
    }
    ::v-deep .rating--uniform.timeline-review {
      display: block;
      text-align: left;
      // margin-bottom: 10px;
      .rate-star--uniform {
        margin-right: 6px;
        span {
          width: 15px !important;
          height: 15px !important;
          background-size: 15px 15px !important;
          &:before {
            height: 15px !important;
            background-size: 15px 15px !important;
          }
        }
      }
    }
    ::v-deep .card-average-rating {
      font-size: 16px;
      line-height: 22px;
    }
  }
  .section-review {
    display: flex;
    padding: 0 16px 5px 16px;
    flex-direction: column;
    gap: 8px;
    align-self: stretch;
    border-radius: 0px 0px 4px 4px;
    background: inherit;
    .review-owner {
      display: flex;
      flex: 1 0 0;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .container-rating-new {
        position: relative;
        display: flex;
        width: 75%;
        gap: 4px;
        align-items: center;
        .average-rating--uniform {
          margin-top: 0 !important;
        }
        .label-shopper {
          width: 16px;
          height: 16px;
          // padding-bottom: 2px;
          display: flex;
          align-items: center;
          position: relative;
          top: -1px;
          @media (max-width: 991px) {
            width: 16px;
            height: 16px;
          }
        }
      }
      .owner {
        width: 25%;
        color: #231f20;
        font-family: 'lato-regular', sans-serif;
        font-size: 12px;
        font-style: normal;
        line-height: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: right;
      }
    }
    .review-detail {
      color: #423c39;
      overflow: hidden;
      font-family: 'lato-regular', sans-serif;
      font-size: 14px;
      font-style: normal;
      line-height: 22px;
      // margin-bottom: 8px;
    }
  }
}
.expert-review {
  background: #fff9fb;
}
</style>
